import * as React from 'react';
import { Typography, Box } from '@mui/material';
import { format, parseISO } from 'date-fns';

export type AnalyticsFreshnessNoteProps = {
    dataThrough: string;
    lastUpdatedAt?: string | null;
    sx?: object;
};

const formatBoldTimestamp = (dataThrough: string, lastUpdatedAt?: string | null) => {
    if (lastUpdatedAt) {
        try {
            const d = parseISO(lastUpdatedAt);
            if (!Number.isNaN(d.getTime())) {
                return format(d, 'MMM d, yyyy · h:mm a');
            }
        } catch {
            // fall through
        }
    }
    return format(new Date(`${dataThrough}T00:00:00`), 'MMM d, yyyy');
};

export const AnalyticsFreshnessNote = ({ dataThrough, lastUpdatedAt, sx }: AnalyticsFreshnessNoteProps) => (
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', marginBottom: 2, ...sx }}>
        Last updated{' '}
        <Box component="span" sx={{ fontWeight: 700, color: 'text.primary' }}>
            {formatBoldTimestamp(dataThrough, lastUpdatedAt)}
        </Box>
    </Typography>
);
